import { ObjectStore, CollectionStore } from '@utils/orm';
import { createInitializeStoresFunction, createGetStoreFunction } from './helpers';

const GROUP_STORE_KEYS = {
  groupStore: 'groupStoreKey',
  configStore: 'configStoreKey',
  sectionsStore: 'sectionsStoreKey',
  recRequestsStore: 'recRequestsStoreKey',
  recObjectsStore: 'recObjectsStoreKey',
  recsStore: 'recsStoreKey',
  searchTermStore: 'searchTermStoreKey',
  fixedNodes: 'fixedNodesKey',
  bookmarkGroupsStore: 'bookmarkGroupsStoreKey',
  bookmarkSelectedStore: 'bookmarkSelectedStoreKey',
  commentStore: 'groupCommentStoreKey',
  submittedCommentStore: 'groupSubmittedCommentStoreKey',
};

const GROUP_STORE_TYPES = {
  groupStore: ObjectStore,
  configStore: ObjectStore,
  sectionsStore: CollectionStore,
  recRequestsStore: CollectionStore,
  recObjectsStore: CollectionStore,
  recsStore: CollectionStore,
  searchTermStore: ObjectStore,
  fixedNodes: CollectionStore,
  bookmarkGroupsStore: CollectionStore,
  bookmarkSelectedStore: ObjectStore,
  commentStore: ObjectStore,
  submittedCommentStore: ObjectStore,
};

export const initializeGroupStores = createInitializeStoresFunction(GROUP_STORE_KEYS, GROUP_STORE_TYPES);
export const getGroupStore = createGetStoreFunction(GROUP_STORE_KEYS, GROUP_STORE_TYPES);
